import React from 'react';
import { AppBar, Toolbar, Box, IconButton, useMediaQuery, useTheme as useMuiTheme } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { useTheme } from '../ThemeContext'; // Import local ThemeContext's useTheme
import LogoutButton from './LogoutButton';
import TenantLogo from './TenantLogo';
import { useAuth } from '../AuthContext';
import logoLight from '../assets/images/logo-light.png';
import logoDark from '../assets/images/logo-dark.png';


interface AppToolbarProps {
  drawerOpen: boolean;
  setDrawerOpen: (open: boolean) => void;
  apiStatus: boolean;
  dbStatus: boolean;
}

const AppToolbar: React.FC<AppToolbarProps> = ({ setDrawerOpen }) => {
  const { mode } = useTheme(); // From local ThemeContext
  const muiTheme = useMuiTheme(); // From @mui/material for breakpoints
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
  const { isAuthenticated, currentTenant } = useAuth();
  // const { t } = useTranslation();

  const logoSrc = mode === 'dark' ? logoDark : logoLight;

  const toolbarMinHeight = isMobile ? 64 : 60;
  const iconSize = isMobile ? 'large' : 'medium';

  return (
    <AppBar
      position="fixed"
      color="default"
      sx={{
        bgcolor: mode === 'dark'
          ? 'rgba(24, 30, 36, 0.85)'
          : 'rgba(255, 255, 255, 0.8)',
        color: 'text.primary',
        backdropFilter: 'blur(20px) saturate(180%)',
        borderBottom: '1px solid',
        borderColor: 'divider',
        boxShadow: 'none',
      }}
    >
      <Toolbar sx={{ minHeight: toolbarMinHeight }}>
        {isAuthenticated && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={() => setDrawerOpen(true)}
            sx={{
              mr: 2,
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'rgba(59, 192, 183, 0.08)',
              },
            }}
          >
            <MenuIcon fontSize={iconSize} />
          </IconButton>
        )}
        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
          <img
            src={logoSrc}
            alt="Logo"
            style={{
              height: isMobile ? 52 : 44,
              transition: 'opacity 0.2s ease',
            }}
          />
          {/* la scuola in cui si sta lavorando, utile a chi ne segue piu' d'una */}
          {isAuthenticated && currentTenant?.logoBlob && (
            <Box sx={{ display: 'flex', alignItems: 'center', ml: { xs: 1.5, sm: 2 }, pl: { xs: 1.5, sm: 2 }, borderLeft: 1, borderColor: 'divider' }}>
              <TenantLogo tenant={currentTenant} scuro={mode === 'dark'} height={isMobile ? 34 : 36} maxWidth={isMobile ? 110 : 180} />
            </Box>
          )}
        </Box>
        <Box>
          {isAuthenticated && <LogoutButton isMobile={isMobile} />}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default AppToolbar;
